import type { ReactNode } from 'react';
import { cn } from '../lib/cn.ts';

export type IconTileTone = 'accent' | 'working' | 'attention' | 'danger' | 'success' | 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/** Soft fill and icon colour per tone: the fill is a faint tint, the icon carries the hue. */
const TONE: Record<IconTileTone, string> = {
  accent: 'bg-accent/12 text-accent-text',
  working: 'bg-status-working-soft text-status-working',
  attention: 'bg-status-attention-soft text-status-attention',
  danger: 'bg-status-danger-soft text-status-danger',
  success: 'bg-status-success-soft text-status-success',
  neutral: 'bg-active text-fg-muted',
  1: 'bg-data-1/14 text-data-1',
  2: 'bg-data-2/14 text-data-2',
  3: 'bg-data-3/14 text-data-3',
  4: 'bg-data-4/14 text-data-4',
  5: 'bg-data-5/14 text-data-5',
  6: 'bg-data-6/14 text-data-6',
  7: 'bg-data-7/14 text-data-7',
  8: 'bg-data-8/14 text-data-8',
};

/**
 * An icon in a small rounded square with a soft tint of its colour: the mark beside a panel
 * title, a stat's label or a list row, so a page reads at a glance. Decorative: the words beside
 * it carry the meaning.
 */
export function IconTile({ icon, tone = 'accent', size = 'md', className }: { icon: ReactNode; tone?: IconTileTone; size?: 'sm' | 'md'; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-control',
        size === 'sm' ? 'size-6 [&_svg]:size-3.5' : 'size-7 [&_svg]:size-4',
        TONE[tone],
        className,
      )}
    >
      {icon}
    </span>
  );
}
